export default function stripTags(string) {
  return (string || "").replace(/<script>(.|\n|\t)+?<\/script>/g, "").replace(/<.+?>/g, "")
}
